import React, { useEffect, useContext, useState } from 'react';
import { Link ,useNavigate } from 'react-router-dom';
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import axios from 'axios';
import {cleanStr,cleanPass} from '../../comfunc.js';
import {strEncode,strDecode} from '../../encrpt.js';
import DataTable from 'react-data-table-component';
import DatePicker from "react-datepicker"; // Ensure you install react-datepicker
import '../Raportee/datatable.css';
import {API_BASE_URL} from "../../apiConfig.jsx";

import * as XLSX from "xlsx";

function RapportsLinked() {
	const navigate = useNavigate();
	useEffect(() => {
		const authToken = localStorage.getItem("authToken");

		if (!authToken) {
			localStorage.removeItem("user"); // Clear user data
			navigate(""); // Ensure correct redirection path
		}
	}, [navigate]);

	  const [userslist, setUserList] = useState([]);
	  const [subcategories, setSubcategories] = useState([]);
	  const [selectedUser, setselectedUser] = useState("");
	  const [subcat, setSubCat] = useState("");
	  const [columns, setColumns] = useState([]);
	  const [tabledata, settableData] = useState([]);
	  const [fromDate, setFromDate] = useState(null);
	  const [toDate, setToDate] = useState(null);
	  const [selectedYear, setSelectedYear] = useState(null);
	
	  useEffect(() => {
		axios.post(`${API_BASE_URL}/api/custom/selectall`,
		{ t: strEncode('pmis_user_mst'), cols: strEncode("*") })
		  .then((response) => setUserList(response.data))
		  .catch((error) => console.error("Error fetching categories:", error));
	  }, []);
	 
	  const handleCategoryChange = (event) => {
		const userId = event.target.value;
		setselectedUser(userId)
	  };

	  const exportData = (type) => {
		const ws = XLSX.utils.json_to_sheet(tabledata);
		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
	
		if (type === "csv") {
		  XLSX.writeFile(wb, "data_export.csv");
		} else {
		  XLSX.writeFile(wb, "data_export.xlsx");
		}
	  };

	 const handleSubmit = async (e) => {
  e.preventDefault();

  // Build WHERE condition dynamically
  const conditions = [];
  if (selectedUser) {
    conditions.push(`n_user = '${selectedUser}'`);
  }
  if (selectedYear) {
    conditions.push(`report_year = '${selectedYear}'`);
  }
  
  const whereClause =
    conditions.length > 0 ? conditions.join(" AND ") + " GROUP BY n_stakeholder_id ORDER BY n_stakeholder_id" : "  GROUP BY n_stakeholder_id ORDER BY n_stakeholder_id";

  try {
    const res = await axios.post(`${API_BASE_URL}/api/custom/selectall`, {
      t: strEncode("v_user_link_rapports_yearwise_monthwise"),
      cols: strEncode("report as Rapport, SUM(CASE WHEN report_month = 1 THEN report_value ELSE 0 END) AS Jan, SUM(CASE WHEN report_month = 2 THEN report_value ELSE 0 END) AS Feb, SUM(CASE WHEN report_month = 3 THEN report_value ELSE 0 END) AS Mar,    SUM(CASE WHEN report_month = 4 THEN report_value ELSE 0 END) AS Apr,    SUM(CASE WHEN report_month = 5 THEN report_value ELSE 0 END) AS May,    SUM(CASE WHEN report_month = 6 THEN report_value ELSE 0 END) AS Jun,    SUM(CASE WHEN report_month = 7 THEN report_value ELSE 0 END) AS Jul,    SUM(CASE WHEN report_month = 8 THEN report_value ELSE 0 END) AS Aug,    SUM(CASE WHEN report_month = 9 THEN report_value ELSE 0 END) AS Sep,    SUM(CASE WHEN report_month = 10 THEN report_value ELSE 0 END) AS Oct,    SUM(CASE WHEN report_month = 11 THEN report_value ELSE 0 END) AS Nov,    SUM(CASE WHEN report_month = 12 THEN report_value ELSE 0 END) AS `Dec`"),
      whrc: strEncode(whereClause),
    });

    // Format columns directly from response
    const columnKeys = Object.keys(res.data[0] || {});
   const formattedColumns = columnKeys.map((key) => ({
		name: key.charAt(0).toUpperCase() + key.slice(1),
		selector: (row) => row[key],
		sortable: true,
		 cell: (row) => {
			// Custom logic: if val > 0 show "Entered", else "Not"
			const monthKeys = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
			if (monthKeys.includes(key)) {
 			return row[key] > 0 ? <span className="badge bg-success">Téléchargé</span> : <span className="badge bg-danger">Non téléchargé</span>;
			}
			return row[key];
		},

		}));

    setColumns(formattedColumns);
    settableData(res.data);
  } catch (error) {
    console.error("Error fetching subcategories:", error);
  }
};	


const handleYearChange = (e) => {
  setSelectedYear(e.target.value);
};

	return (
		<div>
			<ol className="breadcrumb float-xl-end">
				<li className="breadcrumb-item"><Link to="/dashboard/v1">Home</Link></li>
				<li className="breadcrumb-item"><Link to="/dashboard/blank">Raportee</Link></li>
				<li className="breadcrumb-item active">Tableau de suivi Rapports</li>
			</ol>
			<h1 className="page-header">Tableau de suivi Rapports</h1>
			<Panel>
				<PanelHeader>Tableau de suivi Rapports (Seuls les rapports liés seront vérifiés)
</PanelHeader>
				<PanelBody>
				<div className="col-xl-12">
				<form id="smart-form-register" className="row row-cols-lg-auto g-3 align-items-center" noValidate onSubmit={handleSubmit}>					
				        <div className="col-12">
				    	<label class="input">Sélectionner un utilisateur :</label>
						<select onChange={handleCategoryChange} class="form-select" value={selectedUser}>
							<option value="">Sélectionner un utilisateur </option>
							{userslist.map((usr) => (
							<option key={usr.id} value={usr.id}>{usr.c_name}</option>
							))}
						</select>
						</div>
						<div className="col-12">
							<label class="input">Sélectionner l'année:</label>
							<select	onChange={handleYearChange} className="form-select" value={selectedYear}>
									<option value="">Sélectionner l'année</option>
									{Array.from({ length: new Date().getFullYear() - 2024 + 1 }, (_, i) => {
										const year = 2024 + i;
											return (
											<option key={year} value={year}>
												{year}
											</option>
											);
										})}
							</select>
							</div>
								<div className="col-12 pull-right">
                                     <button type="submit" className="btn btn-sm btn-primary" style={{ margin:"20px" }}>
											Soumettre
											</button>

								  <button type="button"  onClick={() => exportData("xlsx")} className="btn btn-sm btn-success ">
								Exporter Excel
								</button>
							</div>
						 </form>
	                  <hr/>
						<div style={{margin:"10px"}}>
							
							<DataTable
									title="Données du rapport"
									columns={columns}
									data={tabledata}
									pagination
									highlightOnHover
								/>
						</div>
						
			
				</div>
					
				</PanelBody>
			</Panel>
			
		</div>
	)
}

export default RapportsLinked;